// @file Display titles for wall access roles shared by preview and share-panel UIs.
import { __ } from '@@/bits/intl'
import { wallAdminRoleLabel } from '@@/bits/wall_admin_role_label'
import { WallAccessRole } from '@@/enums'

/**
 * Localised title for a wall access role. `admin` follows the `renameAdminOwnerToCreator` flip.
 */
function wallAccessRoleTitle(role: WallAccessRole, options: { isWhiteboard: boolean }): string {
  switch (role) {
    case WallAccessRole.None:
      return __('No access')
    case WallAccessRole.Reader:
      return __('Reader')
    case WallAccessRole.Commenter:
      return __('Commenter')
    case WallAccessRole.Writer:
      return __('Writer')
    case WallAccessRole.Moderator:
      return options.isWhiteboard ? __('Editor') : __('Moderator')
    case WallAccessRole.Admin:
      return wallAdminRoleLabel(__('Admin'), __('Creator'))
    default:
      return role
  }
}

export { wallAccessRoleTitle }
